<template>
  <div class="grid">
    <div class="common-title" id="TEAM-BUILDING">
      <div class="common-title-content">
        业务场景
      </div>
    </div>
    <div class="intro">
      <img src="@/assets/images/home/syzl.png" />
      <div class="content">
        <h4>市域治理</h4>
        <p>
          瞄准基层治理最核心的痛点及难点，提升基层部门的治理能力和模式。实现数据资源整合、信息互通、服务输送、矛盾化解。
        </p>
      </div>
    </div>
    <div class="imgBox">
      <div class="img-item">
        <img src="@/assets/images/home/zhsq.png" />
        <div class="content">
          <h4>智慧社区</h4>
          <p>
            克服传统小区的管理短板，大幅减少小区突发安防事故，做到数据全面采集、信息安全传输、决策高效分析、要素靶向治理。
          </p>
        </div>
      </div>
      <div class="img-item">
        <img src="@/assets/images/home/zhyq.png" />
        <div class="content">
          <h4>智慧园区</h4>
          <p>
            深入洞察园区管理的核心需求，采用数据+产业运营融合的手段，助力园区实现管理可视化、流程规范化、服务智能化。
          </p>
        </div>
      </div>
      <div class="img-item">
        <img src="@/assets/images/home/zhxq.png" />
        <div class="content">
          <h4>智慧校园</h4>
          <p>
            将数字技术与校园教学、管理深度融合，能够实现学生安全、智慧教学、数字办公、智能管理的实质提升。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "scene",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.grid {
  .intro {
    position: relative;
    width: 86.05rem;
    height: 18.8rem;
    margin: 0 auto 1.6rem;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      transition: all 0.8s ease-out;
    }
    .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 100;
      h4 {
        padding-top: 8.3rem;
        font-size: 1.5rem;
        font-weight: normal;
        color: #ffffff;
        text-align: center;
        transition: all 0.5s ease;
      }
      p {
        width: 60rem;
        margin: 3.5rem auto 0;
        font-size: 1.1rem;
        color: #ffffff;
        line-height: 1.5;
        opacity: 0;
        transition: all 0.5s ease;
        text-align: justify;
        text-indent: 2em;
      }
    }
    &:hover {
      img {
        // filter: blur(2px);
        transform: scale(1.05);
      }
      .content {
        h4 {
          padding-top: 4rem;
        }
        p {
          display: block;
          opacity: 1;
        }
      }
    }
  }
  .imgBox {
    width: 86.05rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .img-item {
      position: relative;
      width: 27.6rem;
      height: 18.75rem;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      overflow: hidden;

      &:nth-child(2) {
        margin: 0 1.6rem;
      }
      img {
        width: 100%;
        height: 100%;
        transition: all 0.5s ease-out;
      }
      &.img-syzl {
        background-image: url("~@/assets/images/home/syzl.png");
      }
      &.img-zhsq {
        background-image: url("~@/assets/images/home/zhsq.png");
      }
      &.img-zhyq {
        background-image: url("~@/assets/images/home/zhyq.png");
      }
      .content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        h4 {
          padding-top: 8.3rem;
          font-size: 1.5rem;
          font-weight: normal;
          text-align: center;
          transition: all 0.5s ease;
        }
        p {
          display: none;
          width: 20.6rem;
          margin: 2.4rem auto 0;
          font-size: 1.1rem;
          line-height: 1.5;
          opacity: 0;
          transition: all 0.5s ease 0.3s;
          text-align: justify;
          text-indent: 2em;
        }
      }
      &:hover {
        /*  &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.25);
          z-index: 9;
        } */
        img {
          position: relative;
          transform: scale(1.05);
          // filter: blur(1px);
        }
        .content {
          h4 {
            padding-top: 4rem;
          }
          p {
            display: block;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
